import React from 'react'
import { NavLink as RouterLink } from "react-router-dom";
const services = [
    {
        _id:'001',
        classIcon:'ion-university',
        title:'Hindu Rajneeti Academy',
        text:'Creating Tomorrow’s Policy Makers.',
        url: "/hindu-rajneeti-academy"
    },
    {
        _id:'002',
        classIcon:'ion-home',
        title:'A4H Temple Rakshak',
        text:' Protecting Temples. Preserving Heritage.',
        url: "/a4h-temple-rakshak"
    },
    {
        _id:'003',
        classIcon:'ion-ios-list-outline',
        title:'A4H Hindu Voter Guide',
        text:'Vote Informed. Vote with Confidence.',
        url: "/a4h-voter-guide"
    },
    {
        _id:'004',
        classIcon:'ion-ios-world',
        title:'A4H Multiple State PACs',
        text:'  Strengthening Hindu Voices Nationwide.',
        url: "/a4h-state-pacs"
    },
    {
        _id:'005',
        classIcon:'ion-ios-calendar-outline',
        title:'Upcoming Events',
        text:'  Connect. Learn. Make an Impact.',
        url: "/events-and-calender"
    },
    {
        _id:'006',
        classIcon:'ion-ios-heart-outline',
        title:'Membership & Volunteering',
        text:' Join the Movement. Make a Difference.',
        url: "/membership-and-volunteer"
    },
    // {
    //     _id:'007',
    //     classIcon:'ion-social-usd-outline',
    //     title:'Donate / Sponsor',
    //     text:'Support cultural pride and civic leadership',
    //     url: "/"
    // },
    // {
    //     _id:'008',
    //     classIcon:'ion-ios-help-outline',
    //     title:'Become our volunteer',
    //     text:'Empower communities and grow as a leader by volunteering with us.',
    //     url: "/"
    // }
]
function Service2() { 
    return (
        <>
        <style>{`
@media (min-width:769px){
  .home2-page #services .section-block-title{
    padding-top:64px !important;
  }

  .home2-page #services .row{
    row-gap:22px;
  }

  .home2-page #services .block-feature-icon{
    min-height:128px !important;
    margin-bottom:32px !important;
  }

  .home2-page #services .block-feature-icon a{
    display:flex;
    align-items:center;
    min-height:128px;
  }

  .home2-page #services .block-feature-icon .icon{
    flex:0 0 120px;
    width:120px;
    height:120px;
  }

  .home2-page #services .block-feature-icon.left .hi-icon{
    float:none;
  }

  .home2-page #services .block-feature-icon.left .block-title{
    flex:1;
    padding:0 0 0 34px;
  }

  .home2-page #services .block-feature-icon .block-title h4{
    margin-bottom:12px !important;
  }

  .home2-page #services .h50{
    height:42px !important;
  }
}

        /* Mobile */
/* Mobile */
@media (max-width:768px){

  .block-feature-icon a{
    display:flex;
    align-items:center;
  }

  .block-feature-icon .icon{
  width:65px;
  height:65px;
  flex:0 0 65px;
  margin-right:8px;   /* Reduced gap */
  margin-left:6px;    /* Move icon left */
  margin-top:-18px;
}

  .block-feature-icon .hi-icon{
    width:65px;
    height:65px;
    display:flex;
    align-items:center;
    justify-content:center;
  }

  .block-feature-icon .hi-icon i{
    font-size:28px;
  }

  .block-feature-icon .block-title{
  flex:1;
  margin-left:-120px;   /* Move text left */
  padding-left:0;
}

  /* Title in one line */
  .block-feature-icon .block-title h4{
    font-size:16px;
    line-height:1.2;
    margin-bottom:6px;
    white-space:nowrap;
    overflow:hidden;
    text-overflow:ellipsis;
  }

  /* Description in one line */
  .block-feature-icon .block-title p{
    font-size:13px;
    line-height:1.2;
    margin:0;
    white-space:nowrap;
    overflow:hidden;
    text-overflow:ellipsis;
  }
}
        `}</style>
        <section  id="services" className="single-bg">
                
                <div className="section-block-title">
                    <div className="bg-dark"></div>
                    <div className="container">
                        <div className="section-sub-title center">
                            <article className="section-title-body white">
                                <h1 className="head-title">
                                    <span className="dark" style={{ fontWeight: '700' }}>
                                        AREAS OF IMPACT
                                    </span>
                                </h1>

                            </article>
                        </div>    
                    </div>
                    <div className="container">
                        <div className="row">
                            {services.map((service)=>(
                            <div className="col-xxl-4 col-md-6"  key={service._id}>
                                <div className="block-feature-icon left">
                                    <RouterLink to={service.url} >
                                        <div className="icon hi-icon-color hi-icon-effect">
                                            <span className="hi-icon"><i className={service.classIcon}></i></span>
                                        </div>
                                        <div className="block-title">
                                            <h4>{service.title}</h4> 
                                            <p>{service.text}</p>
                                        </div>
                                    </RouterLink>
                                </div>
                            </div>
                            ))}
                        </div>
                    </div>
                    <div className="h50"></div>
                </div>
        </section>
        </>
    )
}

export default Service2
